// Module
var code = ` <div ng-show="show" disable-keyboard="show" disable-keyboard-allow="16,18,27,32,alt+67,alt+68,alt+72,alt+82,alt+80,alt+83,alt+86,alt+87,alt+88,112,113,114,115,116,117,118,119,120,121,122,123" class="overlay" tabindex="1001"> <div class="w-100 h-100 include_overlay"> </div> </div>`;
// Exports
var _module_exports =code;;
var path = '/core/overlay/overlay.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;